export default __webpack_public_path__ + "static/media/quality-features.1c7e6e90.png";